import { useApiClient } from '@/composables/api/client'
import type {
  IndexLocationsResponse,
  IndexLocationsVariables,
  IndexSearchMetaResponse,
  IndexSearchResponse,
  IndexSearchVariables,
  ShowMapResponse,
  ShowMapVariables,
} from '@/types/api/search'

export const useApiSearch = () => {
  const { apiClient } = useApiClient()

  const indexLocations = (params: IndexLocationsVariables) =>
    apiClient.get<IndexLocationsResponse>('locations', {
      params,
    })

  const indexSearch = (params: IndexSearchVariables) =>
    apiClient.get<IndexSearchResponse>('listings/search', {
      params,
    })

  const showMap = (params: ShowMapVariables) =>
    apiClient.get<ShowMapResponse>('listings/map', {
      params,
    })

  const showSearchMeta = (params: IndexSearchVariables) =>
    apiClient.get<IndexSearchMetaResponse>('listings/search/meta', {
      params,
    })

  return {
    indexLocations,
    indexSearch,
    showMap,
    showSearchMeta,
  }
}
